import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';


const API_BASE = process.env.REACT_APP_API_BASE;

export default function Login() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); 
  
  const handleLogin = async () => {
    setIsLoading(true);
    const res = await fetch(`${API_BASE}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json();
    if (res.ok) {
      login(data.token, data.user);
      if (!data.user.firstLoginCompleted) {
        navigate('/selectindustry');
      } else if(data.user.userType === "master") {
navigate('/admin');
      }
      else {
        navigate('/dashboard');
    } }
    else {
        setMessage(data.message || 'Login failed');
        setMessageType('error');
        setTimeout(() => {
            setMessage('');
            setMessageType('');
          }, 4000);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    document.title = "Login – Ennoverse";
  }, []);

  useEffect(() => {
    const message = localStorage.getItem('redirectMessage');
    if (message) {
      toast.warning(message); // or toast.error(message)
      localStorage.removeItem('redirectMessage');
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-6 bg-white rounded shadow-md">
      <div className="flex justify-center mb-6">
  <img src="/ennoverse.png" alt="Ennoverse Logo" className="h-10" />
</div>
        <h2 className="text-xl font-semibold mb-4 text-center text-gray-700">{t('Log In')}</h2>

        <input
          className="w-full p-2 border rounded mb-4"
          type="email"
          placeholder={t('Email')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          className="w-full p-2 border rounded mb-4"
          type="password"
          placeholder={t('Password')}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
<div className="mb-4 text-right">
          <Link to="/forgot-password" className="text-sm text-blue-600 hover:underline">
            {t('Forgot Password?')}
          </Link>
        </div>
        <button
          onClick={handleLogin}
          disabled={isLoading}
          className="w-full bg-primary hover:bg-red-600 text-white py-2 rounded transition duration-200"
        >
          {isLoading ? 'Logging in...' : t('Log In')}
        </button>
        {message && (
  <div
    className={`mt-4 p-3 rounded text-sm margin-top-50 ${
      messageType === 'success'
        ? 'bg-green-100 text-green-700 border border-green-300'
        : 'bg-red-100 text-red-700 border border-red-300'
    }`}
  >
    {message}
  </div>
)}

        <p className="mt-4 text-center text-sm">
          {t("Don't have an account?")}{' '}
          <Link to="/signup" className="text-blue-600 hover:underline">
            {t('Sign Up')}
          </Link>
        </p>

        <div className="mt-6 text-center text-xs text-gray-500">
  By continuing, you agree to our{' '}
  <a href="https://www.ennoverse.ai/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
    Privacy Policy
  </a>{' '}
  and{' '}
  <a href="https://www.ennoverse.ai/terms" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
    Terms & Conditions
  </a>.
</div>

      </div>
    </div>
  );
}
